import { Button, Spin } from 'antd';
import imgBg from '@/assets/images/login/pic_bg.jpg';
import imgLogo from '@/assets/images/logo.png';
import imgFeishuLogo from '@/assets/images/logo-small.png';
import { useFeishuLogin } from '@/pages/login/hooks/useFeishuLogin';
import './index.less';

const Login: React.FC = () => {
	const {
		qrRef,
		organizeType,
		loading,
		selectedOrg,
		handleOrgChange,
		handleLogin,
	} = useFeishuLogin();

	if (loading) {
		return (
			<div className="login-spin">
				<Spin tip="登录中..." spinning={loading} size="large" />
			</div>
		);
	}

	return (
		<div className="login">
			<div className="login-content">
				<img className="login-bg" src={imgBg} alt="background" />
				<div className="login-logo">
					<img src={imgLogo} alt="logo" />
				</div>
			</div>

			<div className="login-card">
				<div className="login-tip">
					<div className="login-title">Welcome！</div>
					<div className="login-desc">Be-Link，让协作更高效</div>
				</div>
				<div className="login-form">
					<div className="login-organize">
						{organizeType.map((item) => (
							<div
								key={item.id}
								className={`login-organize-item ${selectedOrg.value === item.value ? 'login-organize-item-selected' : ''}`}
								onClick={() => handleOrgChange(item)}
							>
								<div className="login-organize-logo">
									<img src={imgFeishuLogo} alt="logo" />
								</div>
								<div className="login-organize-text">{item.label}</div>
								{selectedOrg.value === item.value && (
									<div className="login-organize-badge">当前组织</div>
								)}
							</div>
						))}
					</div>
					<div className="login-qr" id="feishu-qr" ref={qrRef} />
					<div className="login-qr-tip">- 扫码后点击"确认"，即可完成登录 -</div>
					<div className="login-buttons">
						<Button block type="primary" onClick={handleLogin} size="large">
							飞书授权一键登录
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
